<template>
    <v-form @submit.prevent="save" novalidate>
        <v-switch
          class="d-inline-block"
          :label="`Email`"
          v-model="form.email"
        ></v-switch>
        <v-switch
          class="d-inline-block"
          :label="`Push (powiadomienia do przeglądarki i mobilne)`"
          v-model="form.push"
        ></v-switch>
        <v-btn type="submit" small color="primary">Zapisz</v-btn>
    </v-form>
</template>

<script>
import {updateUserSettings, fetchUserSettings} from './api'
import iziToast from 'izitoast'

export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      formErrors: {},
      form: {
      }
    }
  },
  created () {
    this.fetchSettings()
  },
  watch: {
    'user': 'fetchSettings'
  },
  methods: {
    fetchSettings () {
      fetchUserSettings().then(data => {
        this.form = data
        this.$emit('push-status', data.push)
      })
    },
    save () {
      let promise = updateUserSettings(this.form)
      promise.then((data) => {
        this.$emit('update-user-settings', data)
        iziToast.show({
          message: 'Ustawienia zostały edytowane',
          color: 'green'
        })
        this.$emit('push-status', data.push)
      }).catch((data) => {
        iziToast.show({
          message: 'Nie udało się edytować ustawień',
          color: 'red'
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/notifications/NotificationsSettings.vue